import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Throttle } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';
import { Popup } from 'semantic-ui-react';

const renderCashBackPercent = (value: number | string): JSX.Element | null => {
  if (!value) return null;

  return (
    <>
      <FormattedNumber value={value as number} style="decimal" />%
    </>
  );
};

const renderDollarAmt = (value: number | string): JSX.Element => {
  if (!value) return <span>$0</span>;

  return (
    <FormattedNumber
      value={value as number}
      style="currency"
      currencyDisplay="symbol"
      currency="USD"
    />
  );
};

const formatThrottle = (throttle: Throttle): JSX.Element => (
  <span>
    {(throttle.max + 1 - throttle.min) / 10}%{' '}
    <span style={{ fontWeight: 'bold' }}>Min </span> {throttle.min / 10}%{' '}
    <span style={{ fontWeight: 'bold' }}>Max </span> {(throttle.max + 1) / 10}%
  </span>
);

const formatThrottleWithTooltip = (throttle: Throttle): JSX.Element => (
  <Popup
    content={
      <>
        <span style={{ fontWeight: 'bold' }}>Min </span> {throttle.min / 10}%
        <br />
        <span style={{ fontWeight: 'bold' }}>Max </span>{' '}
        {(throttle.max + 1) / 10} %
        <br />
        <span style={{ fontWeight: 'bold' }}>Total </span>{' '}
        {(throttle.max + 1 - throttle.min) / 10}%
      </>
    }
    header="Throttle"
    trigger={<span>{(throttle.max + 1 - throttle.min) / 10}%</span>}
  />
);
interface Classes {
  spacer: string;
  textLabel: string;
}

const renderInlineField = (
  label: string,
  value: any,
  { spacer, textLabel }: Classes,
): JSX.Element => (
  <span className={spacer}>
    <span className={textLabel}>{label}</span>
    {value}
  </span>
);

const renderBlockField = (
  label: string,
  value: any,
  { spacer, textLabel }: Classes,
): JSX.Element => (
  <div className={spacer}>
    <span className={textLabel}>{label}</span>
    {value}
  </div>
);

export {
  renderCashBackPercent,
  renderDollarAmt,
  formatThrottle,
  formatThrottleWithTooltip,
  renderInlineField,
  renderBlockField,
};
